document.querySelectorAll('.js-quick-add-form').forEach(function(form) {
  form.addEventListener('submit', function(event) {
    event.preventDefault();
    var variantId = this.querySelector('button.quick-add').getAttribute('data-variant-id');
    var quantity = 1;
    var data = {id: variantId, quantity: quantity};

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(data)
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      // Refresh the cart drawer
      Shopify.getCart(function(cart) {
        ShopifyDrawer.cartDrawer(cart);
      });
    });
  });
});